import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=f569e1be&scoped=true&"
import script from "./SaveButton.vue?vue&type=script&lang=js&"
export * from "./SaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f569e1be",
  null
  
)

export default component.exports